import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Screen } from '../../components';
import { makeStyles } from '@mui/styles';
import {
  APIEndpoints,
  ChooseIntegration,
  CustomizeIntegration,
  FAQs,
  GettingStarted,
  RetrievingResults,
  Schemas,
  Typings,
} from './components';
const useStyles = makeStyles((theme) => ({
  screen: {
    width: '96%',
    margin: '10px auto auto',
  },
  dashboard: {
    width: '92%',
    margin: 'auto',
    '& h2': {
      width: '100%',
      fontSize: 20,
      marginTop: 20,
      marginBottom: 20,
      color: theme.palette.admin.main,
      display: 'block',
    },
  },
  patientLists: {
    marginTop: 20,
  },
}));

const APIDocScreen = () => {
  const classes = useStyles();
  return (
    <Screen
      title={'API / Integration Docs - Diet ID'}
      showSidebarNav={false}
      showAPISidebarNav={true}
      admin={true}
      onHoverExpand={false}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        className={classes.screen}
      >
        <Typography variant={'subtitle1'}>Diet ID API Integration Documentation</Typography>
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={4}
          className={classes.dashboard}
        >
          <GettingStarted />
          <RetrievingResults />
          <ChooseIntegration />
          <CustomizeIntegration />
          <APIEndpoints />
          {/*<Typings />*/}
          <Schemas />
          <FAQs />
        </Grid>
      </Grid>
    </Screen>
  );
};

export default APIDocScreen;
